import React from 'react';

interface Text {
  text: string;
}

const AdditionalInformationLabel = (text: Text): JSX.Element => {
  return <>{text.text}</>;
};

export default AdditionalInformationLabel;
